window.MW_getOwnedHandles = function () {
  if (!window.MW_IS_LOGGED_IN) return new Set();
  var owned = new Set();
  document.querySelectorAll('[data-mw-product-owned="true"][data-product-handle]').forEach(function (element) {
    var handle = element.dataset.productHandle;
    if (handle) owned.add(handle);
  });

  if (window.MWProductOffers && window.MWProductOffers.getDynamicOwnedHandles) {
    window.MWProductOffers.getDynamicOwnedHandles().forEach(function (handle) {
      owned.add(handle);
    });
  }
  return owned;
};

(function () {
  'use strict';

  window.MWCartUI = {

    _drawerTimer: null,


    init: function () {
      this._setupDrawerObserver();
      this._initCartPageRemoveLinks();
      this._initCartPageAddReload();
    },


    _setupDrawerObserver: function () {
      var self = this;
      var drawerProducts = document.querySelector('#CartDrawer [data-products]');
      if (!drawerProducts) return;

      var observer = new MutationObserver(function () {
        clearTimeout(self._drawerTimer);
        self._drawerTimer = setTimeout(function () {
          self._updateDrawerSummary();
          self._initDrawerRemoveLinks();
        }, 60);
      });

      observer.observe(drawerProducts, { childList: true });
    },


    _updateDrawerSummary: function () {
      var self = this;
      var drawerFooter = document.querySelector('#CartDrawer .drawer__footer');
      if (!drawerFooter) return;

      var cartItemsEl = document.querySelector('#CartDrawer [data-products] .cart__items');
      if (!cartItemsEl) return;

      var totalDiscounts = parseInt(cartItemsEl.dataset.cartSavings || 0, 10);

      var items = cartItemsEl.querySelectorAll('.cart__item[data-key]');
      var fullSubtotal = 0;
      var compareSavings = 0;
      items.forEach(function (el) {
        var originalPrice  = parseInt(el.dataset.originalPrice  || 0, 10);
        var compareAtPrice = parseInt(el.dataset.compareAtPrice || 0, 10);
        var qty            = parseInt(el.dataset.quantity       || 1, 10);
        var itemBase = (compareAtPrice > originalPrice) ? compareAtPrice : originalPrice;
        if (compareAtPrice > originalPrice) {
          compareSavings += (compareAtPrice - originalPrice) * qty;
        }
        fullSubtotal += itemBase * qty;
      });

      var fmt = function (cents) {
        var moneyFormat = window.theme && theme.settings && theme.settings.moneyFormat;
        return moneyFormat
          ? self._formatMoney(cents, moneyFormat)
          : '$' + (cents / 100).toFixed(2);
      };

      var ovVal = drawerFooter.querySelector('[data-order-value] .mw-summary-value');
      if (ovVal) ovVal.textContent = fmt(fullSubtotal);

      var tdRow = drawerFooter.querySelector('[data-total-discounts]');
      if (tdRow) {
        var tdVal = tdRow.querySelector('.mw-summary-value');
        if (tdVal) tdVal.textContent = '-' + fmt(totalDiscounts);
        tdRow.style.display = totalDiscounts > 0 ? '' : 'none';
      }

      var csRow = drawerFooter.querySelector('[data-compare-savings]');
      if (csRow) {
        var csVal = csRow.querySelector('.mw-summary-value');
        if (csVal) csVal.textContent = '-' + fmt(compareSavings);
        csRow.style.display = compareSavings > 0 ? '' : 'none';
      }
    },


    _initDrawerRemoveLinks: function () {
      var self = this;
      var productsEl = document.querySelector('#CartDrawer [data-products]');
      if (!productsEl) return;

      productsEl.querySelectorAll('.cart__item[data-key]').forEach(function (itemEl) {
        var key = itemEl.dataset.key;
        if (!key) return;

        if (itemEl.querySelector('.mw-remove-item')) return;

        var nameDiv = itemEl.querySelector('.cart__item--name');
        if (!nameDiv) return;

        var link = document.createElement('a');
        link.href = '#';
        link.className = 'mw-remove-item';
        link.textContent = 'Remove';
        link.setAttribute('aria-label', 'Remove item from cart');

        link.addEventListener('click', function (e) {
          e.preventDefault();
          link.textContent = '\u2026';
          link.style.pointerEvents = 'none';

          self._removeFromCart(key)
            .then(function () {
              document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                bubbles: true,
                detail: { _mwRemove: true }
              }));
            })
            .catch(function () {
              link.textContent = 'Remove';
              link.style.pointerEvents = '';
            });
        });

        nameDiv.appendChild(link);
      });
    },


    _initCartPageRemoveLinks: function () {
      var self = this;
      var productsEl = document.querySelector('#CartPageForm [data-products]');
      if (!productsEl) return;

      productsEl.querySelectorAll('.cart__item[data-key]').forEach(function (itemEl) {
        var key = itemEl.dataset.key;
        if (!key) return;

        var nameDiv = itemEl.querySelector('.cart__item--name');
        if (!nameDiv) return;

        var link = document.createElement('a');
        link.href = '#';
        link.className = 'mw-remove-item';
        link.textContent = 'Remove';
        link.setAttribute('aria-label', 'Remove item from cart');

        link.addEventListener('click', function (e) {
          e.preventDefault();
          link.textContent = '\u2026';
          link.style.pointerEvents = 'none';

          self._removeFromCart(key)
            .then(function () { window.location.reload(); })
            .catch(function () {
              link.textContent = 'Remove';
              link.style.pointerEvents = '';
            });
        });

        nameDiv.appendChild(link);
      });
    },


    _initCartPageAddReload: function () {
      if (!document.body.classList.contains('template-cart')) return;
      document.addEventListener('ajaxProduct:added', function (e) {
        if (e.detail && e.detail._mwRemove) return;
        window.location.reload();
      });
    },



    _getCart: function () {
      return fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); });
    },

    _removeFromCart: function (lineKey) {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      });
    },


    _formatMoney: function (cents, format) {
      if (typeof Currency !== 'undefined' && Currency.formatMoney) {
        return Currency.formatMoney(cents, format);
      }
      return format
        .replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    }

  };

  document.addEventListener('DOMContentLoaded', function () {
    MWCartUI.init();
  });

})();

(function () {
  var STORAGE_KEY = 'mw_hide_owned_collection';

  var STYLE_ID = 'mw-hide-owned-styles';

  function applyHideOwned(hide) {
    var existing = document.getElementById(STYLE_ID);

    if (!hide) {
      if (existing) existing.remove();
      var empty = document.getElementById('mw-collection-owned-empty');
      if (empty) empty.classList.remove('is-visible');
      return;
    }

    var ownedHandles = window.MW_getOwnedHandles ? window.MW_getOwnedHandles() : new Set();
    if (!ownedHandles.size) {
      if (existing) existing.remove();
      var empty = document.getElementById('mw-collection-owned-empty');
      if (empty) empty.classList.remove('is-visible');
      return;
    }

    var rules = Array.from(ownedHandles).map(function (handle) {
      return '#CollectionAjaxContent .grid__item.grid-product[data-product-handle="' + CSS.escape(handle) + '"] { display: none !important; }';
    }).join('\n');

    var styleEl = existing || document.createElement('style');
    styleEl.id = STYLE_ID;
    styleEl.textContent = rules;
    if (!existing) document.head.appendChild(styleEl);

    setTimeout(function () {
      var cards = document.querySelectorAll('#CollectionAjaxContent .grid__item.grid-product[data-product-handle]');
      var visibleCount = 0;
      cards.forEach(function (card) {
        if (card.offsetParent !== null) visibleCount++;
      });
      var empty = document.getElementById('mw-collection-owned-empty');
      if (empty) empty.classList.toggle('is-visible', visibleCount === 0);
    }, 50);
  }

  function initHideOwnedToggle() {
    var toggle = document.getElementById('mw-hide-owned-toggle');
    if (!toggle) return;

    var gridContent = document.getElementById('CollectionAjaxContent');
    if (gridContent && !document.getElementById('mw-collection-owned-empty')) {
      var emptyDiv = document.createElement('div');
      emptyDiv.id = 'mw-collection-owned-empty';
      emptyDiv.className = 'mw-hide-owned-empty';
      emptyDiv.textContent = 'No products left to show. Try turning off Hide Owned.';
      gridContent.appendChild(emptyDiv);
    }

    if (window.MW_IS_LOGGED_IN) {
      var saved = sessionStorage.getItem(STORAGE_KEY);
      if (saved === 'true') {
        toggle.checked = true;
        applyHideOwned(true);
      } else {
        applyHideOwned(false);
      }
    }

    if (toggle.dataset.mwOwnedBound) return;
    toggle.dataset.mwOwnedBound = 'true';
    toggle.addEventListener('change', function (e) {
      e.stopPropagation();
      var wantsOn = toggle.checked;

      if (wantsOn && !window.MW_IS_LOGGED_IN) {
        toggle.checked = false;
        var returnTo = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.href = '/customer_authentication/login?return_to=' + returnTo;
        return;
      }

      sessionStorage.setItem(STORAGE_KEY, wantsOn ? 'true' : 'false');
      applyHideOwned(wantsOn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHideOwnedToggle);
  } else {
    initHideOwnedToggle();
  }
  document.addEventListener('collection:reloaded', initHideOwnedToggle);
  document.addEventListener('shopify:section:load', initHideOwnedToggle);
})();
